import {forwardRef, SVGProps} from 'react';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SortIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => {
	const {direction} = props;
	const up = direction === 'asc';
	const noDirection = !direction;
	return <svg style={{cursor: 'pointer'}} width='9' height='10' viewBox='0 0 9 10' fill='none' xmlns='http://www.w3.org/2000/svg'
	            {...props}
	            ref={ref}>
		<path d='M0.0358887 4.14722L4.46167 0.452627L8.88745 4.14722H0.0358887Z'
		      fill={noDirection ? '#BDBDBD' : up ? '#666666' : '#BDBDBD'}/>
		<path d='M0.0358887 6.08972L4.46167 9.78431L8.88745 6.08972H0.0358887Z'
		      fill={noDirection ? '#BDBDBD' : up ? '#BDBDBD' : '#666666'}/>
	</svg>;
});

SortIcon.displayName = 'SortIcon';

export default SortIcon;
